// extracted by mini-css-extract-plugin
export default {"stats":"stats_stats__oQQIQ","ordersBoard":"stats_ordersBoard__9tIj+"};